/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/organization",
    name: "Dashboard",
    slug: "dashboard",
    icon: "GridIcon",
  },
  {
    url: "/organization/edit-profile",
    name: "Edit Profile",
    slug: "edit-profile",
    icon: "UserIcon",
  },
  {
    url: "/organization/settings",
    name: "Settings",
    slug: "settings",
    icon: "SettingsIcon",
  },
  {
    url: "/organization/messages",
    name: "Messages",
    slug: "messages",
    icon: "MessageCircleIcon",
  },
  {
    url: "/organization/marketplace",
    name: "Marketplace",
    slug: "marketplace",
    icon: "ShoppingBagIcon",
  }
]
